export default "__VITE_ASSET__a7688a02__"